import { colors } from "./colors";

export const environments = env => ({
  apps: {
    colors: {
      gridLineColor: colors.gridLineColor,
    },
    barThickness: 10,
    xAxis: {
      display: true,
      drawTicks: true,
    },
    yAxis: {
      display: true,
      gridLines: true,
    },
  },
  ios_widget_small: {
    colors: {
      gridLineColor: "rgb(25, 25,25)",
    },
    barThickness: 5,
    xAxis: {
      display: false,
      drawTicks: false,
    },
    yAxis: {
      display: false,
      gridLines: false,
      maxTicksLimit: 0,
    },
  },
  ios_widget_medium: {
    colors: {
      gridLineColor: "rgb(25, 25,25)",
    },
    barThickness: 10,
    xAxis: {
      display: true,
      drawTicks: true,
    },
    yAxis: {
      display: true,
      gridLines: true,
      maxTicksLimit: 3,
    },
  },
  ios_widget_large: {
    colors: {
      gridLineColor: "rgb(25, 25,25)",
    },
    barThickness: 10,
    xAxis: {
      display: true,
      drawTicks: true,
    },
    yAxis: {
      display: true,
      gridLines: true,
      maxTicksLimit: 5,
    },
  },
})[['apps','ios_widget_small','ios_widget_medium', 'ios_widget_large'].includes(env) ? env : unsupportedEnvironment(env)]

// This function is called when an unsupported environment is selected and returns the default environment "apps"
const unsupportedEnvironment = (env) => {
  console.warn(`Unsupported environment ${env} selected. Defaulting to environment "apps"`)
  return "apps"
}